import { memo } from "react";

interface AnimationWrapperProps {
  isSubInProcess: boolean;
  failedInscription: boolean;
  children: React.ReactNode;
}

/**
 * Componente aislado para manejar las animaciones de la card.
 * Usa React.memo con una comparación personalizada para evitar re-renders innecesarios.
 */
const AnimationWrapper = memo(
  ({ isSubInProcess, failedInscription, children }: AnimationWrapperProps) => {
    const showFailedAnimation = failedInscription ? "cancel-animation" : "";
    //const showFailedAnimation = "";
    const showFillAnimation = isSubInProcess ? "fill-animation" : "";
    return (
      <div className={`animation-wrapper ${showFailedAnimation}`}>
        <div className={`${showFillAnimation}`}></div>
        {children}
      </div>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.isSubInProcess === nextProps.isSubInProcess &&
      prevProps.failedInscription === nextProps.failedInscription &&
      prevProps.children === nextProps.children
    );
  }
);

AnimationWrapper.displayName = "AnimationWrapper";

export default AnimationWrapper;

